export const formatZAR = (value: unknown): string => {
  const numericValue =
    typeof value === 'number' ? value : parseInt(String(value), 10);

  if (!Number.isFinite(numericValue)) return 'R0';

  if (numericValue % 1000 === 0) {
    return `R${numericValue / 1000}k`;
  }

  return `R${numericValue.toLocaleString('en-ZA', {
    maximumFractionDigits: 0,
  })}`;
};
